export type SidePanelType =
  | { type: 'addSection' }
  | { type: 'addSubject' }
  | { type: 'addToMap' }
  | { type: 'assignTeacher'; sectionId: number; subjectId: number; subjectName: string; currentTeacherId: number | null }
  | { type: 'classTeacher'; section: any; role: 'primary' | 'secondary' }
  | { type: 'cloneSection'; targetSectionId: number; targetLabel: string }
  | { type: 'loadTemplate'; boardId: number; gradeLabel: string; classId: number };

export const CATEGORY_COLORS: Record<string, string> = {
  language: 'bg-blue-100 text-blue-600',
  core: 'bg-purple-100 text-purple-600',
  social: 'bg-amber-100 text-amber-600',
  activity: 'bg-pink-100 text-pink-600',
  skill: 'bg-teal-100 text-teal-600',
  sports: 'bg-green-100 text-green-600',
  elective: 'bg-gray-100 text-gray-500',
};

export const GRADE_ORDER: Record<string, number> = {
  PLAYGROUP: 0, NURSERY: 1, LKG: 2, UKG: 3,
  '1': 4, '2': 5, '3': 6, '4': 7, '5': 8,
  '6': 9, '7': 10, '8': 11,
  '9': 12, '10': 13,
  '11': 14, '12': 15,
};

export const CARD_CATS = ['cat-blue', 'cat-purple', 'cat-green', 'cat-teal', 'cat-amber', 'cat-rose', 'cat-indigo', 'cat-peach'];
export const CATEGORY_ORDER = ['language', 'core', 'social', 'skill', 'activity', 'sports', 'elective'];

export const GRADE_GROUPS = [
  { label: 'Early Years', grades: ['Playgroup', 'Nursery', 'LKG', 'UKG'] },
  { label: 'Primary',     grades: ['Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5'] },
  { label: 'Middle',      grades: ['Class 6', 'Class 7', 'Class 8'] },
  { label: 'Secondary',   grades: ['Class 9', 'Class 10'] },
  { label: 'Senior',      grades: ['Class 11', 'Class 12'] },
];

export function detectGradeLabel(className: string): string | null {
  const n = className.toLowerCase().trim();
  if (/playgroup|play\s*group|\bpg\b/.test(n)) return 'PLAYGROUP';
  if (/nursery/.test(n)) return 'NURSERY';
  if (/lkg|lower\s*kg|lower\s*kindergarten/.test(n)) return 'LKG';
  if (/ukg|upper\s*kg|upper\s*kindergarten/.test(n)) return 'UKG';
  const romanMap: Record<string, string> = { xii: '12', xi: '11', x: '10', ix: '9', viii: '8', vii: '7', vi: '6', v: '5', iv: '4', iii: '3', ii: '2', i: '1' };
  for (const [roman, num] of Object.entries(romanMap)) {
    if (new RegExp(`\\b${roman}\\b`).test(n)) return num;
  }
  const m = n.match(/\b(1[0-2]|[1-9])\b/);
  return m ? m[1] : null;
}

export function gradeOrder(name: string): number {
  const label = detectGradeLabel(name);
  return label != null && GRADE_ORDER[label] != null ? GRADE_ORDER[label] : 999;
}
